<template>

    <div class="timeline row"
     v-show="$route.query.expanded!=true && $route.query.expanded !== 'true'"
    :class="{'course-timeline': isCoursePage, 'mentor': localStorage.roles.includes('Mentor')}"
    :style="{'background': courseBackground()}">
        {{getCurrentWeek}}
        <div class="col-sm-12"  v-if="!noTerm">
        <div class="current-week col-sm-3" v-if="$store.getters.currentTerm">
            <i class="clippie clippie-float-right fa fa-info-circle" v-tooltip="'You can drag this timeline to scroll it. Clicking past weeks will show you the content for that week (great for reviewing the past)'"></i>
            <span v-if="new Date($store.getters.currentTerm.startDate) <= new Date()" class="week-number">
                <span v-if="isVideoPlayer">
                    Week {{timeTravelWeek + 1}}                  
                </span>
                <span v-else>
                    Week {{currentWeek + 1}}
                </span>
            </span>
            <span v-else class="week-number">Week 1</span>
            <span v-if="new Date($store.getters.currentTerm.startDate) <= new Date()" class="week-days">{{weekDays}}</span>
            <span v-else class="week-days">Starts {{$store.getters.currentTerm.startDate | dayMonthYear}}</span>
        </div>
        <carousel :easing="'linear'" :paginationEnabled="false" :perPage="10" class="weeks col-sm-9" :class="{'': isCoursePage, 'course-timeline': isCoursePage}" ref="weeks">
            <slide class="week" v-for="(week,$index) in weeks">
              
                <span 
                v-if="isVideoPlayer"
                @click.prevent="goToWeek($index)" 
                v-bind:class="{'past': ($index < currentWeek), 
                             'current': ($index === currentWeek && timeTravelWeek === null) || (isVideoPlayer && $index === timeTravelWeek), 
                             'future': ((timeTravelWeek && timeTravelWeek.toString()) && $index > currentWeek) }">
                Week {{week}}
                <i v-if="$index === currentWeek"></i>
                <i v-if="(isVideoPlayer && $index === timeTravelWeek) || (timeTravelWeek === null && $index === currentWeek)" class="fa fa-circle"></i>
                </span>


                <span 
                v-else
                @click.prevent="goToWeek($index)" 
                v-bind:class="{'past': $index < currentWeek, 
                             'current': $index === currentWeek, 
                             'future': $index > currentWeek }">
                Week {{week}}
                <i v-if="$index === currentWeek"></i>
                <i v-if="(isVideoPlayer && $index === timeTravelWeek) || (timeTravelWeek === null && $index === currentWeek)" class="fa fa-circle"></i>
                </span>

            </slide>
        </carousel>
        </div>

        <div v-else class="col-sm-12">
        <div class="current-week col-sm-3">
            <span class="week-number">Week 1</span>
            <span class="week-days">Starts {{localStorage.intake}}</span>
        </div>

            <carousel :easing="'linear'" :paginationEnabled="false" :perPage="10" class="weeks col-sm-9" :class="{'': isCoursePage, 'course-timeline': isCoursePage}" ref="weeks">
            <slide class="week" v-for="(week,index) in 16">

                <span 
                    @click.prevent="goToWeek(index)" 
                    v-bind:class="{'past': index < currentWeek, 'current': index + 1 === currentWeek, 'future':index > currentWeek }">
                Week {{week}} 

                <i v-if="index === currentWeek " class="fa fa-circle"></i>
                </span>

            </slide>
        </carousel></div>

        <div
            class="col-xs-12"
            v-if="showGalleries">
            <latest-galleries></latest-galleries>
        </div>



        <div class="term-selector col-xs-12" v-if="!localStorage.roles.includes('Mentor') && terms && ($route.name === 'home' || $route.name === 'mentorDashboard') && localStorage.terms &&  localStorage.terms != 'null'">

                <ul class="term-tabs" v-if="isInMentorship()">
                    <li v-for="term in terms"
                    v-if="term.type !== 'mentorship' && !term.name.toLowerCase().includes('challenge')"
                    @click="changeTerm(term)"
                    :class="[
                    {'active':term.id==selectedTerm && $route.name === 'home'},
                    {'no-click': localStorage.roles.includes('CampusStudent')},
                    {'future': isInFuture(term.startDate)},
                    term.type]"
                    >

                        <router-link :to="{path: '/home', query:{term: term.id}}">
                            <span v-if="term.type === 'foundation'">Fundamentals</span>
                            <span v-else-if="term.type === 'mentorship'">Portfolio Production</span>
                            <span v-else>{{term.type | capitalize}}</span>
                        </router-link>

                    </li>
                    <li v-if="localStorage.terms.toString().split(',').length === 4" :class="{'active': $route.name === 'mentorDashboard'}" class="mentorship">
                        <router-link :to="{path:'/mentor-dashboard'}">Portfolio Production</router-link>
                    </li>

                </ul>
                <ul class="term-tabs" v-else>
                    <li v-for="term in terms"
                    v-if="term.type !== 'mentorship' && !term.name.toLowerCase().includes('challenge')"
                    @click="changeTerm(term)"
                    :class="[
                    {'active':term.id==selectedTerm},
                    {'no-click': localStorage.roles.includes('CampusStudent')},
                    {'future': isInFuture(term.startDate)},
                    term.type]"
                    >
                        <span v-if="term.type === 'foundation'">Fundamentals</span>
                        <span v-else-if="term.type === 'mentorship'">Portfolio Production</span>
                        <span v-else>{{term.type | capitalize}}</span>
                    </li>
                    <li
                    v-if="localStorage.terms.toString().split(',').length === 4"
                    :class="{'active': $route.name === 'mentorDashboard'}" class="mentorship">
                        <router-link :to="{path:'/mentor-dashboard'}">Portfolio Production</router-link>
                    </li>

                </ul>
                <span class="divider"></span>

        </div>

    </div>
</template>


<script>

    import terms from '../../services/terms';
    import LatestGalleries from './LatestGalleries.vue';

    import moment from 'moment';
    import { Carousel, Slide } from '../../packages/vue-carousel';

    export default {
        props: {
            showGalleries: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                currentWeek: null,
                timeTravelWeek: null,
                isVideoPlayer: null,
                weekLimit:null,
                weeks: null,
                noTerm: false,
                selectedTerm: null,                
                tabColors: ['#3ac384', '#deb704', '#8a85de', '#3cf'],
                selectedEnrollment: 'none'

            }
        },
        components: {
            Carousel,
            Slide,
            LatestGalleries,
        },
        
        mounted() {
            var self = this;

            this.isVideoPlayer = this.$route.name === 'videoPlayer';

            if (this.$route.query.week) {
                this.timeTravelWeek = parseInt(this.$route.query.week) - 1;
                this.$forceUpdate();
            }
            if (localStorage.terms == 'null') {
                this.noTerm = true;
            } else {

                if (!this.$store.getters.currentTerm) {
                    self.getTerms();
                } else {
                    self.selectedTerm = this.$store.getters.currentTerm.id;
                    self.getWeeks();
                }
            }

            if (this.$route.query.term && this.$route.name === 'home') {
                let term = this.terms.find(function(t) { return t.id == self.$route.query.term});
                self.changeTerm(term)
            }


       
            //failsafe to hide the loader after 10 seconds
            setTimeout(function() {
                self.$store.dispatch('toggle',{type:'loading', boolean: false});
            },10000)

        },
        methods: {
           
           
            isInMentorship() {
                return localStorage.terms.toString().split(',').length === 4;
            },
            isInFuture(startDate) {
                return moment(startDate).subtract(1,'week').toDate() > new Date();

            },
            changeTerm: function(term) {
                var self = this;
                if (moment(term.startDate).subtract(1,'week').toDate() > new Date()) return false;
                self.selectedTerm = term.id;
                let terms = this.terms;

                let newTerm = terms.findIndex(function(t) { return t.id === self.selectedTerm});
                newTerm = terms[newTerm];

                let data = {
                    type: 'currentTerm',
                    data: newTerm
                }

                this.$store.dispatch('populate', data);

                this.getWeeks();

            },
            courseBackground() {

                var self = this;
                if (this.$store.getters.courses) {
                if (this.$route.name === 'course' || this.$route.name === 'videoPlayer') {
                    var courses = this.$store.getters.courses;
                    var index = courses.findIndex(function(c) { return c.id == self.$route.params.instanceId || c.instanceid == self.$route.params.courseId});
                    if (index > -1) {
                        return 'linear-gradient(to bottom, rgba(15, 15, 15, 0.5) 0%, rgba(15, 15, 15, 0.8) 70%, rgba(15, 15, 15, 1) 90%), url("' + courses[index].associated.image + '") no-repeat center center/cover';
                    }

                }
            }
                return 'transparent';
            },
            goToWeek(week) {

                if ( (new Date(this.$store.getters.currentTerm.endDate) > new Date()) && (week > this.weekLimit)) return false;
                this.currentWeek = week;
                var data = {
                    type: 'currentWeek',
                    data: week
                }
                if (this.$route.name === 'videoPlayer') {
                    this.$bus.$emit('weekChanged',week);
                }

                sessionStorage.setItem('timeTravelWeek',week);

                this.$store.dispatch('populate', data);
            },
            getTerms() {
                var self = this;

                terms.get(this).then(function(response) {

                    let courseSets = {};
                    if (localStorage.selectedCourseSets) courseSets = JSON.parse(localStorage.selectedCourseSets);

                    let now = new Date();
                    let myTerms = localStorage.terms;
                   // if (myTerms.indexOf(',') === -1) myTerms += ',';
                    let termIds = myTerms.split(',');
                    let studentTerms = response.data.terms.filter(function(t) {
                        return termIds.indexOf(t.id) > -1;
                    }).map(function(t) {
                        if (t.courseSets && t.courseSets.length && localStorage.has_course_sets === 'true') {
                            let selected = courseSets[t.id];
                            if (selected) {
                                t.selectedCourseSet = selected;
                            } else {
                                t.selectedCourseSet = t.courseSets[0].id;
                            }
                        } else {
                            t.selectedCourseSet = null;
                        }
                        return t;
                    }).sort(function(a,b) {
                        return new Date(b.startDate) - new Date(a.startDate);
                    })

                    let data = {
                        type: 'terms',
                        data: studentTerms
                    }

                    self.$store.dispatch('populate', data);

                    let currentTerm = studentTerms.findIndex(function(t) {
                        return new Date(t.startDate) < now && new Date(t.endDate) > now;
                    });

                    if (currentTerm === -1) {
                        studentTerms = studentTerms.sort(function(a, b) { return new Date(b.endDate) - new Date(a.endDate)});
                        currentTerm = 0;
                    }

                    currentTerm = studentTerms[currentTerm];
                    self.selectedTerm = currentTerm.id;
                    self.$store.dispatch('populate', {type: 'currentTerm', data: currentTerm});
                    self.getWeeks();
                });

        },
        getWeeks() {
                var self = this;
                var term = this.$store.state.currentTerm;
                var weeks = moment(term.endDate).diff(moment(term.startDate),'week') + 1;
                var startDate = moment(term.startDate).startOf('day').format('YYYY-MM-DD');
                var now = new Date();

                var pst = moment().tz('America/Vancouver').format('YYYY-MM-DD');

                var currentWeek;

                var isOngoing = new Date(term.startDate) < now && new Date(term.endDate) > now;

                if (isOngoing) {
                     currentWeek = moment(pst).diff(moment(startDate), 'weeks');
                } else {
                    // this is a past semester, so go back to week 1
                    currentWeek = 15;
                }

                var weekStart = moment(startDate).add(currentWeek,'weeks');

                var weekEnd = weekStart.clone().add(6,'days');
                this.weekStart = weekStart.format('MMM D');
                this.weekEnd = weekEnd.format('MMM D');
                this.currentWeek = currentWeek;
                this.weeks = weeks;

                if (currentWeek >= 10) {
                    self.$nextTick(function() {
                        if (self.$refs.weeks) {
                            self.$refs.weeks.goToPage(2);
                        }
                    });
                }
 
            
                var data = {
                    type: 'termWeeks',
                    data: weeks
                }

                self.$store.dispatch('populate', data);

                if (new Date(term.startDate) > new Date()) currentWeek = -1;
                self.weekLimit = currentWeek;

                data = {
                    type: 'currentWeek',
                    data: currentWeek
                }
                self.$store.dispatch('populate', data);

                data = {
                    type: 'realCurrentWeek',
                    data: currentWeek
                }

                self.$store.dispatch('populate', data)

                if (this.$route.name === 'videoPlayer' && sessionStorage.getItem('timeTravelWeek')) {
                    if (!this.$route.query.week) {
                        this.timeTravelWeek = parseInt(sessionStorage.getItem('timeTravelWeek'));
                        this.$forceUpdate();
                    }
                    

                }
            },
        },
        watch: {
            '$route.query': function(week) {
                this.timeTravelWeek = week.week - 1;
            }
        },
        computed: {
            terms() {
                if (this.$store.getters.terms) {                    
                    return this.$store.getters.terms.sort(function(a, b) {
                        if (!a || !b) return;
                        return new Date(a.startDate) - new Date(b.startDate)
                    });                 
                }
            },
            isCoursePage() {
                if (this.$route.name === 'course' || this.$route.name === 'videoPlayer') return true;
                return false;

            },
            getCurrentWeek() {
                if (this.$store.state.currentWeek) {

                   this.currentWeek = this.$store.state.currentWeek;
                }
            },
            weekDays() {
                if (this.$store.state.currentTerm) {
                    var term = this.$store.state.currentTerm;
                    var currentWeek = this.$store.getters.currentWeek;
                    let weekStart;
                    if (parseInt(this.timeTravelWeek) > -1) {
                        weekStart = moment(term.startDate).add(this.timeTravelWeek,'weeks');
                    } else {
                        weekStart = moment(term.startDate).add(currentWeek,'weeks');
                    }
                    var weekEnd = weekStart.clone().add(6,'days');
                    weekStart = weekStart.format('MMM D');
                    weekEnd = weekEnd.format('MMM D');
                    return weekStart + ' - ' + weekEnd;
                }
            },

        }
    }
</script>

<style lang="scss">
        .weeks .VueCarousel-wrapper {
           height:100px;
           background:#111;
        }
        .weeks.course-timeline {
            .VueCarousel-wrapper {
                background:transparent;
            }

        }
        .term-tabs {
        display:flex;
        flex-direction:row;
        margin-bottom:-20px;
        z-index: 9999;
        position: relative;
        a {
            color:#fff!important;
            text-decoration:none!important;
        }
        li {
            color:#fafafa;
            font-size:2rem;
            font-weight:300;
            padding:1.5rem 1.5rem 1rem;
            margin-right: 2rem;
            cursor:pointer;
            &.future {
                cursor: default;
                opacity: .5;
            }
            &.active {
                color:#010000;
                font-weight:600;
                z-index: 9;
                &::after {
                    width:100%;
                    max-width: 1366px;
                    height:2px;
                    display:block;
                    bottom:0;
                    content:'';
                    position:absolute;
                    left:0;
                 }
            }
        }
        li:first-child {
            background:#222;
            &.active {
                background: #3ac384;
                &::after {
                    background: #3ac384;

                }
            }
        }
        li:nth-child(2) {
            background: #2E2E2E;
            &.active {
                background:#deb704;
                &::after {
                    background:#deb704;
                }
            }
        }
        li:nth-child(3) {
            background: #1f1f1f;
            &.active {
                background: #8a85de;
                &::after {
                    background: #8a85de;
                }
            }
        }
        li:nth-child(4) {
            background: #1f1f1f;
            &.active {
                background: #3cf;
                &::after {
                    background: #3cf;
                }
            }
        }
    }
</style>

<style lang="scss" scoped>


    .course-timeline {
        height:160px;
        .current-week {
            //transform: translateX(-3rem);
            box-shadow: 0px 0px 20px 3px rgba(0,0,0,.7);
        }
    }
    .current-week {
        background: rgba(54,54,54,.8);
        height: 100px;
        padding: 10px 2rem 0 2rem;
        text-align:center;
        color:white;
        font-weight:100;
        text-shadow: 2px 2px 6px black;

        .week-number {
            font-size:4rem;
            padding:0;
            display:block;
            margin-top:-5px;
            margin-bottom:-12px
        }
        .week-days {
            font-size:2rem;
        }
    }

    .weeks {
        position:relative;
        height:100px;
        padding:0;

        .week {
           display:table-cell;
           & > span {
             cursor:pointer;
           }
           & > span.future {
             cursor: default;
           }
        }
        .week:nth-child(odd) {
            padding-top:4rem;
            i {
                position: absolute;
                bottom: 22px;
                left: 22px;
            }
        }
        .week:nth-child(even) {
            padding-bottom:4rem;
            vertical-align: bottom;
            i {
                position: absolute;
                bottom: -18px;
                left: 22px;
            }
        }

        .past {
            text-shadow: 0px 0px 6px black;
            //color:white!important;
        }
        .current {
            text-shadow: 0px 0px 6px black;
            color: #33ccff ;
            font-weight:700;
            position:relative;
        }
        .future {
            opacity: .25;
        }

        &::after {
            content:'';
            width:100%;
            background:#33ccff;
            height:1px;
            display:block;
            position:absolute;
            top:50%;
            box-shadow: 0px 0px 10px #33ccff;
        }
    }
    .no-click {
        cursor:default;
        pointer-events:none;
    }

    .fa-circle {
        text-shadow: 0px 0px 10px #33ccff;
        color: #33ccff;
    }
    .col-sm-12 {
        padding-right:0;
    }

    .latest-galleries {
        margin-bottom: 0;
    }


</style>



// WEBPACK FOOTER //
// Timeline.vue?1ec4c8a6